import ko from 'knockout';
import BaseViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import { get as getDefaultLanguage } from '@bingads-webui-component-legacy/language-selector/util/defaultLanguage';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

export default class ViewModel {
  constructor(model) {
    BaseViewModel.call(this);
    this.showPreviewButton(false);
    this.showPanel = ko.observable(true);
    this.selectedEntityCount(model.get('selectedEntityCount'));
    this.selectedLanguages = ko.observable([getDefaultLanguage()]);
    this.titleText = ko.computed(() => {
      const entityCount = this.selectedEntityCount();

      if (entityCount > 1) {
        return  i18n.getString('EditCampaignsLanguageTitle', entityCount );
      }

      return  i18n.getString('EditCampaignLanguageTitle', entityCount );
    }, this);

    this.errorRole = ko.computed(() => {
      const error = this.errorMessage();

      return error === '' ? 'none' : 'alert';
    }, this);

    this.validate = () => {
      if (this.selectedLanguages().length < 1) {
        this.errorMessage(i18n.getString('Campaign_Validation_LanguageSelectionRequired'));
        return false;
      }
      this.errorMessage('');
      return true;
    };
  }
}
